type EdgeNavButtonProps = {
  side: "left" | "right";
  onClick: () => void;
  ariaLabel?: string;
  disabled?: boolean;
};

export default function EdgeNavButton({
  side,
  onClick,
  ariaLabel,
  disabled,
}: EdgeNavButtonProps) {
  const positionClass = side === "left" ? "left-2" : "right-2";
  const iconClass =
    side === "left" ? "ri-arrow-left-s-line" : "ri-arrow-right-s-line";

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`absolute ${positionClass} top-1/2 -translate-y-1/2 w-10 h-10 bg-black/30 hover:bg-black/60 text-white rounded-full flex items-center justify-center transition-all cursor-pointer backdrop-blur-sm opacity-0 hover:opacity-100 disabled:opacity-30`}
    >
      <i className={`${iconClass} text-xl`}></i>
    </button>
  );
}
